import { Site } from '../../models';
import { getSites } from '../../services';
import * as actionTypes from './types';

export const setSitesData = (value) => ({
  type: actionTypes.SET_SITES_DATA,
  value: value,
});

export const fetchSites = () => async (dispatch, getState) => {
  const { account, authenticityToken } = getState().internalReducer.internal;
  dispatch(setSitesData({ data: [], error: null, loading: true }));

  try {
    const data = await getSites({
      accountId: account.id,
      authenticityToken: authenticityToken,
    });

    dispatch(setSitesData({ data: data.map((site) => new Site(site)), error: null, loading: false }));
  } catch (error) {
    dispatch(setSitesData({ data: [], error: error, loading: false }));
  }
};
